module.exports = __webpack_public_path__ + "img/phone(1).3531a0cb.png";